<!-- 新的统一模板项目管理组件 -->
<template>
  <div class="template-item-manager">
    <!-- 主界面：左右分栏 -->
    <a-modal
      v-model="visible"
      title="模板项目管理"
      :width="1200"
      :footer="null"
      @cancel="handleCancel"
      :bodyStyle="{ padding: '16px', height: '70vh', overflow: 'hidden' }"
    >
      <div class="manager-container">
        <!-- 左侧：主项目列表 -->
        <div class="left-panel">
          <div class="panel-header">
            <h4>主项目列表</h4>
            <a-button type="primary" size="small" icon="plus" @click="addMainItem">
              新增主项目
            </a-button>
          </div>
          
          <div class="item-list" :loading="loading">
            <div 
              v-for="item in mainItems" 
              :key="item.id"
              :class="['item-card', { active: selectedMainItem?.id === item.id }]"
              @click="selectMainItem(item)"
            >
              <div class="item-header">
                <span class="item-no">{{ item.item_no }}</span>
                <div class="item-tags">
                  <a-tag :color="item.star === 'high' ? 'red' : 'blue'" size="small">
                    {{ item.star === 'high' ? '高' : '低' }}
                  </a-tag>
                </div>
              </div>
              <a-tooltip :title="item.item_name">
                <div class="item-name fixed-width">
                  {{ item.item_name }}
                </div>
              </a-tooltip>
              <div class="item-actions">
                <a-button-group size="small">
                  <a-button icon="edit" @click.stop="editMainItem(item)">编辑</a-button>
                  <!-- 批量删除（包含子项） -->
                  <a-popconfirm 
                    :title="getDeleteConfirmText(item)" 
                    @confirm="smartDeleteMainItem(item)"
                    ok-text="确定删除"
                    cancel-text="取消"
                  >
                    <a-button 
                      type="danger" 
                      icon="delete" 
                      @click.stop
                      :loading="deletingItems[item.id]"
                    >
                      删除
                    </a-button>
                  </a-popconfirm>
                </a-button-group>
              </div>
              <div class="child-count">
                子项目: {{ item.child_count || 0 }}
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧：子项目详情 -->
        <div class="right-panel">
          <div class="panel-header">
            <h4>
              {{ selectedMainItem ? `${selectedMainItem.item_name} - 子项目` : '请选择主项目' }}
            </h4>
            <a-button 
              v-if="selectedMainItem"
              type="primary" 
              size="small" 
              icon="plus" 
              @click="addChildItem"
            >
              新增子项目
            </a-button>
          </div>

          <div v-if="selectedMainItem" class="child-list">
            <div 
              v-for="child in childItems" 
              :key="child.id"
              class="child-item"
            >
              <div class="child-row">
                <div class="child-main">
                  <div class="child-header">
                    <span class="child-no">{{ child.item_no }}</span>
                    <a-tag :color="getInputTypeColor(child.input_type)" size="small">
                      {{ getInputTypeLabel(child.input_type) }}
                    </a-tag>
                    <a-tag :color="child.star === 'high' ? 'red' : 'blue'" size="small">
                      {{ child.star === 'high' ? '高' : '低' }}
                    </a-tag>
                  </div>
                  <a-tooltip :title="child.item_name">
                    <div class="child-name fixed-width">
                      {{ child.item_name }}
                    </div>
                  </a-tooltip>
                </div>

                <div class="child-actions">
                  <a-button-group size="small">
                    <a-button icon="edit" @click="editChildItem(child)">编辑</a-button>
                    <a-popconfirm title="确定删除?" @confirm="deleteChildItem(child.id)">
                      <a-button type="danger" icon="delete">删除</a-button>
                    </a-popconfirm>
                  </a-button-group>
                </div>
              </div>
            </div>
            
            <div v-if="childItems.length === 0" class="empty-state">
              <a-empty description="暂无子项目">
                <a-button 
                  type="primary" 
                  @click="addChildItem" 
                  icon="plus"
                  style="margin-top: 16px;"
                >
                  添加子项目
                </a-button>
              </a-empty>
            </div>
          </div>

          <div v-else class="empty-state">
            <a-empty description="请在左侧选择一个主项目" />
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 主项目表单抽屉 -->
    <a-drawer
      :visible="mainItemDrawerVisible"
      :title="mainItemMode === 'add' ? '新增主项目' : '编辑主项目'"
      width="500"
      @close="handleMainItemDrawerClose"
    >
      <a-form-model
        ref="mainItemForm"
        :model="mainItemForm"
        :rules="mainItemRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="项目编号" prop="item_no">
          <a-input v-model="mainItemForm.item_no" placeholder="请输入项目编号" />
        </a-form-model-item>
        <a-form-model-item label="项目名称" prop="item_name">
          <a-input v-model="mainItemForm.item_name" placeholder="请输入项目名称" />
        </a-form-model-item>
        <a-form-model-item label="重要性" prop="star">
          <a-select v-model="mainItemForm.star" placeholder="请选择重要性">
            <a-select-option value="low">低</a-select-option>
            <a-select-option value="high">高</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sort_order">
          <a-input-number v-model="mainItemForm.sort_order" :min="0" placeholder="请输入排序" />
        </a-form-model-item>
        
        <!-- 模板关联管理 -->
        <a-form-model-item label="关联模板">

          
          <a-spin :spinning="loadingTemplates">
            <a-select
              v-model="selectedTemplates"
              mode="multiple"
              :placeholder="loadingTemplates ? '正在加载模板列表...' : (allTemplates.length > 0 ? '选择要关联的模板' : '暂无可用模板')"
              :disabled="loadingTemplates"
              allow-clear
              show-search
              :filter-option="filterTemplateOption"
              style="width: 100%;"

            >
              <!-- 使用 a-select-option 方式，移除可能冲突的 dropdownRender -->
              <a-select-option 
                v-for="template in allTemplates" 
                :key="`template-${template.id}`" 
                :value="template.id"
                :title="template.description || template.template_name || template.title"
              >
                {{ template.template_name || template.name || template.title || template.label || `模板${template.id}` }}
              </a-select-option>
              
              <!-- 当没有选项时显示提示 -->
              <a-select-option v-if="allTemplates.length === 0" disabled value="" key="no-template">
                暂无可用模板
              </a-select-option>
            </a-select>
          </a-spin>
          
          <!-- 显示关联统计信息 -->
          <div v-if="selectedTemplates.length > 0" class="template-relation-info">
            <small style="color: #1890ff;">
              <a-icon type="link" />
              已选择 {{ selectedTemplates.length }} 个模板，保存后将建立关联关系
            </small>
          </div>
        </a-form-model-item>
      </a-form-model>
      
      <div class="drawer-footer">
        <a-button @click="handleMainItemDrawerClose" style="margin-right: 8px">
          取消
        </a-button>
        <a-button type="primary" @click="handleMainItemSubmit" :loading="mainItemSubmitting">
          确定
        </a-button>
      </div>
    </a-drawer>

    <!-- 子项目表单抽屉 -->
    <a-drawer
      :visible="childItemDrawerVisible"
      :title="childItemMode === 'add' ? '新增子项目' : '编辑子项目'"
      width="600"
      @close="handleChildItemDrawerClose"
    >
      <a-form-model
        ref="childItemForm"
        :model="childItemForm"
        :rules="childItemRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="子项目编号" prop="item_no">
          <a-input v-model="childItemForm.item_no" placeholder="请输入子项目编号" />
        </a-form-model-item>
        <a-form-model-item label="子项目名称" prop="item_name">
          <a-input v-model="childItemForm.item_name" placeholder="请输入子项目名称" />
        </a-form-model-item>
        <a-form-model-item label="输入类型" prop="input_type">
          <a-select 
            v-model="childItemForm.input_type" 
            placeholder="请选择输入类型"
            @change="onInputTypeChange"
          >
            <a-select-option :value="1">
              <span>单选</span>
              <small style="color: #999; margin-left: 8px;">从预设选项中选择一个</small>
            </a-select-option>
            <!-- <a-select-option :value="2">
              <span>短文本</span>
              <small style="color: #999; margin-left: 8px;">单行文本输入，如温度、重量</small>
            </a-select-option>
            <a-select-option :value="3">
              <span>多选</span>
              <small style="color: #999; margin-left: 8px;">从预设选项中选择多个</small>
            </a-select-option>
            <a-select-option :value="4">
              <span>长文本</span>
              <small style="color: #999; margin-left: 8px;">多行文本，如详细描述、问题记录</small>
            </a-select-option> -->
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="选项配置" prop="option_id" v-if="[1, 3].includes(Number(childItemForm.input_type))">
          <!-- 动态选项编辑器 -->
          <div class="option-editor">
            <div 
              v-for="(option, index) in optionList" 
              :key="index" 
              class="option-item"
            >
              <a-input 
                v-model="optionList[index]" 
                placeholder="请输入选项文本"
                @change="updateOptionId"
                style="flex: 1; margin-right: 8px;"
              />
              <a-button 
                type="danger" 
                size="small" 
                icon="delete" 
                @click="removeOption(index)"
                :disabled="optionList.length <= 1"
              />
            </div>
            <a-button 
              type="dashed" 
              size="small" 
              icon="plus" 
              @click="addOption"
              style="width: 100%; margin-top: 8px;"
            >
              添加选项
            </a-button>
          </div>
          
          <!-- 显示最终生成的option_id供调试 -->
          <div class="option-preview" v-if="childItemForm.option_id">
            <small style="color: #666;">
              生成配置: {{ childItemForm.option_id }}
            </small>
          </div>
        </a-form-model-item>
        
        <!-- 模板文本：只对输入框和文本区域类型显示 -->
        <a-form-model-item 
          label="模板文本" 
          prop="template_text" 
          v-if="[2, 4].includes(Number(childItemForm.input_type))"
        >
          <a-textarea 
            v-model="childItemForm.template_text" 
            :placeholder="getTemplateTextPlaceholder()"
            :rows="3" 
            @focus="handleTemplateTextFocus"
            @blur="handleTemplateTextBlur"
            @input="handleTemplateTextInput"
            :class="{ 'template-suggested': !templateTextEdited && childItemForm.template_text }"
          />
          <div class="input-hint">
            <span v-if="!templateTextEdited && childItemForm.template_text" style="color: #1890ff;">
              💡 智能建议已填入，点击编辑框可自定义内容
            </span>
            <span v-else>
              提示：模板文本用于生成动态内容，可使用 {变量名} 作为占位符
            </span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="重要性" prop="star">
          <a-select v-model="childItemForm.star" placeholder="请选择重要性">
            <a-select-option value="low">低</a-select-option>
            <a-select-option value="high">高</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sort_order">
          <a-input-number v-model="childItemForm.sort_order" :min="0" placeholder="请输入排序" />
        </a-form-model-item>
      </a-form-model>
      
      <div class="drawer-footer">
        <a-button @click="handleChildItemDrawerClose" style="margin-right: 8px">
          取消
        </a-button>
        <a-button type="primary" @click="handleChildItemSubmit" :loading="childItemSubmitting">
          确定
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { INPUT_TYPE_LABELS, clearTemplateCache } from '@/config/templates.js';
import { 
  listItems, 
  addItem, 
  updateItem, 
  deleteItem, 
  listChildItems, 
  addChildItem, 
  updateChildItem, 
  deleteChildItem,
  listTemplates, // 添加模板列表API
  getItemTemplateRelations // 添加获取主项目关联模板的API
} from '@/api/daily';

export default {
  name: 'TemplateItemManager',
  data() {
    return {
      visible: false,
      loading: false,
      
      // 主项目相关
      mainItems: [],
      selectedMainItem: null,
      mainItemDrawerVisible: false,
      mainItemMode: 'add',
      mainItemForm: {},
      mainItemSubmitting: false,
      
      // 子项目相关
      childItems: [],
      childItemDrawerVisible: false,
      childItemMode: 'add',
      childItemForm: {
        parent_item_id: null,
        item_no: '',
        item_name: '',
        star: 'low',
        input_type: 2,
        option_id: '',
        template_text: '',
        sort_order: 0,
        status: 1
      },
      childItemSubmitting: false,
      
      // 模板文本编辑状态
      templateTextEdited: false, // 跟踪用户是否已经编辑过模板文本
      
      // 智能操作状态
      deletingItems: {}, // 删除操作的loading状态（使用项目id作为key）
      
      // 模板关联管理
      allTemplates: [], // 所有可用模板列表
      selectedTemplates: [], // 当前主项目关联的模板
      loadingTemplates: false, // 加载模板列表状态
      
      // 子项目统计信息（主项目ID -> 子项目数量）
      // childItemCounts: {},
      
      // 选项列表管理
      optionList: ['符合', '不符合'],
      
      // 表单验证规则
      mainItemRules: {
        item_no: [{ required: true, message: '请输入项目编号', trigger: 'blur' }],
        item_name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        star: [{ required: true, message: '请选择重要性', trigger: 'change' }]
      },
      childItemRules: {
        item_no: [{ required: true, message: '请输入子项目编号', trigger: 'blur' }],
        item_name: [{ required: true, message: '请输入子项目名称', trigger: 'blur' }],
        input_type: [{ required: true, message: '请选择输入类型', trigger: 'change' }],
        star: [{ required: true, message: '请选择重要性', trigger: 'change' }],
        option_id: [
          {
            validator: (rule, value, callback) => {
              const inputType = Number(this.childItemForm?.input_type);
              if ([1, 3].includes(inputType) && (!value || value.trim() === '')) {
                callback(new Error('选择和多选类型必须提供选项配置'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    };
  },
  
  computed: {
    // 模板选项列表 - 格式化为 Ant Design Select 组件需要的格式
    templateOptions() {
      ('计算templateOptions，allTemplates:', this.allTemplates);
      
      if (!this.allTemplates || this.allTemplates.length === 0) {
        ('allTemplates为空，返回空数组');
        return [];
      }
      
      const options = this.allTemplates.map(template => {
        ('处理模板:', template);
        
        // 兼容不同的字段名
        const templateName = template.template_name || template.name || template.title || `模板${template.id}`;
        const templateDesc = template.description || template.desc || template.template_name || templateName;
        
        const option = {
          value: template.id,
          label: templateName,
          title: templateDesc,
          disabled: false
        };
        
        ('生成选项:', option);
        return option;
      });
      
      ('最终templateOptions:', options);
      return options;
    }
  },
  
  methods: {
    // 显示管理器
    show() {
      this.visible = true;
      this.loadMainItems();
      
      // 预加载模板列表，提升用户体验
      if (this.allTemplates.length === 0) {
        this.loadTemplateList().catch(() => {
          // 静默失败，用户点击时会重新加载
        });
      }
    },
    
    // 关闭管理器
    handleCancel() {
      this.visible = false;
      this.selectedMainItem = null;
      this.childItems = [];
    },
    
    // 获取输入类型标签
    getInputTypeLabel(type) {
      return INPUT_TYPE_LABELS[type] || '未知';
    },
    
    // 获取输入类型颜色
    getInputTypeColor(type) {
      const colors = { 1: 'blue', 2: 'green', 3: 'orange', 4: 'purple' };
      return colors[type] || 'default';
    },
    
    // // 获取子项目数量
    // getChildCount(mainItemId) {
    //   return this.childItemCounts[mainItemId] || 0;
    // },
    
    // 选择主项目
    selectMainItem(item) {
      this.selectedMainItem = item;
      this.loadChildItems(item.id);
    },
    
    // 加载主项目列表
    async loadMainItems() {
      try {
        this.loading = true;
        // 增加 page_size 参数，假设后端支持
        const response = await listItems({ page: 1, page_size: 100 });
        if (response && response.code === 200) {
          const items = response.data?.data || response.data || [];
          // 应用自然排序
          this.mainItems = items.sort((a, b) => this.naturalSort(a, b));
          
          // 优化：使用后端返回的 children_count 字段，如果没有则设为 0
          // 不再主动调用 loadChildItemCounts()，避免多次 API 调用
          this.mainItems.forEach(item => {
            // 使用后端返回的字段，如果没有则设为未知状态
            if (typeof item.children_count !== 'undefined') {
              item.child_count = item.children_count;
            } else if (typeof item.child_count === 'undefined') {
              item.child_count = 0; // 默认值
            }
          });
          
          if (this.mainItems.length === 0) {
            this.$message.info('暂无主项目数据，请先添加主项目');
          }
        } else {
          this.$message.error(response?.message || '加载主项目失败');
        }
      } catch (error) {
        this.$message.error('加载主项目失败');
        console.error('加载主项目失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // 批量加载所有主项目的子项目数量（按需使用，避免初始化时调用）
    async loadChildItemCounts() {
      if (this.mainItems.length === 0) return;
      
      try {
        // 为每个主项目查询子项目数量
        const countPromises = this.mainItems.map(async (item) => {
          try {
            // 优化：只获取第一页数据并使用 count 字段
            const response = await listChildItems({ 
              parent_item_id: item.id,
              page: 1,
              page_size: 1 // 只获取1条数据，主要是为了得到 count
            });
            
            if (response && response.code === 200) {
              // 优先使用 count 字段，如果没有则使用数组长度
              const count = response.data?.count ?? response.count ?? (response.data?.data || response.data || []).length;
              item.child_count = count;
            } else {
              item.child_count = 0;
            }
          } catch (error) {
            console.error(`加载主项目 ${item.id} 的子项目数量失败:`, error);
            item.child_count = 0;
          }
        });
        
        await Promise.all(countPromises);
        
        // 强制更新视图
        this.$forceUpdate();
      } catch (error) {
        console.error('加载子项目数量失败:', error);
      }
    },
    
    // // 加载所有主项目的子项目统计
    // async loadAllChildItemCounts() {
    //   if (this.mainItems.length === 0) return;
      
    //   try {
    //     // 并发请求所有主项目的子项目数量
    //     const countPromises = this.mainItems.map(async (item) => {
    //       try {
    //         const response = await listChildItems({ 
    //           parent_item_id: item.id,
    //           page: 1,
    //           page_size: 1 // 只需要获取统计数量，不需要具体数据
    //         });
    //         return {
    //           parentId: item.id,
    //           count: response?.count || 0
    //         };
    //       } catch (error) {
    //         console.error(`加载主项目 ${item.id} 的子项目统计失败:`, error);
    //         return {
    //           parentId: item.id,
    //           count: 0
    //         };
    //       }
    //     });
        
    //     const results = await Promise.all(countPromises);
        
    //     // 更新统计数据
    //     this.childItemCounts = {};
    //     results.forEach(result => {
    //       this.childItemCounts[result.parentId] = result.count;
    //     });
        
    //   } catch (error) {
    //     console.error('加载子项目统计失败:', error);
    //   }
    // },
    
    // 自然排序函数 - 用于正确排序编号（如：1.1, 1.2, ..., 1.10, 1.11）
    naturalSort(a, b) {
      const itemNoA = (a.item_no || '').toString();
      const itemNoB = (b.item_no || '').toString();
      
      // 分割编号为数字部分进行比较
      const partsA = itemNoA.split('.').map(part => parseInt(part) || 0);
      const partsB = itemNoB.split('.').map(part => parseInt(part) || 0);
      
      // 逐段比较
      const maxLength = Math.max(partsA.length, partsB.length);
      for (let i = 0; i < maxLength; i++) {
        const numA = partsA[i] || 0;
        const numB = partsB[i] || 0;
        if (numA !== numB) {
          return numA - numB;
        }
      }
      
      return 0;
    },

    // 加载子项目列表
    async loadChildItems(parentId) {
      try {
        const response = await listChildItems({ parent_item_id: parentId });
        
        if (response.code === 200) {
          const items = response.data?.data || response.data || [];
          // 应用自然排序
          this.childItems = items.sort((a, b) => this.naturalSort(a, b));
        } else {
          this.$message.error(response.message || '加载子项目失败');
        }
      } catch (error) {
        this.$message.error('加载子项目失败');
        console.error('加载子项目失败:', error);
      }
    },
    
    // 主项目操作方法
    async addMainItem() {
      this.mainItemMode = 'add';
      this.mainItemForm = { star: 'low', sort_order: 0, status: 1 };
      this.selectedTemplates = []; // 清空模板选择
      
      // 先显示抽屉，然后立即开始加载模板列表
      this.mainItemDrawerVisible = true;
      
      // 异步加载模板列表，不阻塞界面显示
      this.loadTemplateList();
    },
    
    async editMainItem(item) {
      this.mainItemMode = 'edit';
      this.mainItemForm = { ...item };
      this.mainItemDrawerVisible = true;
      
      // 加载模板列表和当前项目的关联模板
      await this.loadTemplateList();
      await this.loadItemTemplateRelations(item.id);
    },
    
    // 旧的deleteMainItem方法已被smartDeleteMainItem替代
    
    // 子项目操作方法
    addChildItem() {
      if (!this.selectedMainItem) {
        this.$message.warning('请先选择一个主项目');
        return;
      }
      this.childItemMode = 'add';
      
      // 生成建议的子项编号
      const suggestedItemNo = this.generateSuggestedChildItemNo();
      
      this.childItemForm = { 
        parent_item_id: this.selectedMainItem.id,
        item_no: suggestedItemNo,
        item_name: '',
        star: 'low', 
        input_type: 1, // 默认使用输入类型，不需要option_id
        option_id: '',
        template_text: '',
        sort_order: this.getNextSortOrder(), 
        status: 1
      };
      
      // 初始化选项列表并同步到option_id
      this.initOptionList();
      this.updateOptionId();
      
      // 重置模板文本编辑状态
      this.templateTextEdited = false;
      
      this.childItemDrawerVisible = true;
      
      this.$nextTick(() => {
        if (this.$refs.childItemForm) {
          this.$refs.childItemForm.clearValidate();
        }
      });
    },
    
    editChildItem(item) {
      this.childItemMode = 'edit';
      this.childItemForm = { ...item };
      this.childItemDrawerVisible = true;
      // 初始化选项列表
      this.initOptionList();
      // 编辑模式下，如果有自定义内容则标记为已编辑
      const smartText = this.getSmartTemplateText(Number(item.input_type));
      this.templateTextEdited = item.template_text !== smartText && item.template_text.trim() !== '';
    },
    
    // 表单提交处理
    async handleMainItemSubmit() {
      try {
        await this.$refs.mainItemForm.validate();
        this.mainItemSubmitting = true;
        
        // 准备提交数据，包含模板关联信息
        const submitData = {
          ...this.mainItemForm,
          template_ids: this.selectedTemplates // 添加选中的模板ID列表
        };
        
        const apiCall = this.mainItemMode === 'add' ? addItem : updateItem;
        const response = await apiCall(submitData);
        
        if (response.code === 200) {
          const templateCount = this.selectedTemplates.length;
          const message = templateCount > 0 
            ? `保存成功，已关联 ${templateCount} 个模板`
            : '保存成功';
            
          this.$message.success(message);
          this.mainItemDrawerVisible = false;
          this.loadMainItems();
          // 清除模板缓存，确保其他页面能获取到最新数据
          clearTemplateCache();
          // 通知父组件刷新数据
          this.$emit('refresh');
        } else {
          this.$message.error(response.message || '保存失败');
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error('保存失败');
      } finally {
        this.mainItemSubmitting = false;
      }
    },
    
    async handleChildItemSubmit() {
      try {
        await this.$refs.childItemForm.validate();
        this.childItemSubmitting = true;
        
        const apiCall = this.childItemMode === 'add' ? addChildItem : updateChildItem;
        const response = await apiCall(this.childItemForm);
        
        if (response && response.code === 200) {
          this.$message.success('保存成功');
          this.childItemDrawerVisible = false;
          this.loadChildItems(this.selectedMainItem.id);
          // 更新当前主项目的子项目数量
          await this.updateSingleItemChildCount(this.selectedMainItem.id);
          // 清除模板缓存，确保日管控页面能获取到最新数据
          clearTemplateCache();
          // 通知父组件刷新数据
          this.$emit('refresh');
        } else {
          this.$message.error(response?.message || '保存失败');
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error('保存失败: ' + (error.message || '未知错误'));
      } finally {
        this.childItemSubmitting = false;
      }
    },
    
    // 抽屉关闭处理
    handleMainItemDrawerClose() {
      this.mainItemDrawerVisible = false;
      this.$refs.mainItemForm.resetFields();
    },
    
    handleChildItemDrawerClose() {
      this.childItemDrawerVisible = false;
      this.$refs.childItemForm.resetFields();
    },
    
    // 输入类型变化处理 - Linux内核式：清晰的职责分离
    onInputTypeChange(value) {
      const inputType = Number(value);
      
      if ([1, 3].includes(inputType)) {
        // 选择/多选类型：需要选项配置，清空模板文本
        if (!this.childItemForm.option_id) {
          this.initOptionList();
          this.updateOptionId();
        }
        // 清空模板文本，因为选择类型不需要模板
        this.childItemForm.template_text = '';
        this.templateTextEdited = false;
      } else if ([2, 4].includes(inputType)) {
        // 输入/文本类型：需要模板文本，清空选项配置
        this.childItemForm.option_id = '';
        this.optionList = [];
        // 重置编辑状态并提供智能建议
        this.templateTextEdited = false;
        this.childItemForm.template_text = this.getSmartTemplateText(inputType);
      } else {
        // 其他未知类型：清空所有相关数据
        this.childItemForm.option_id = '';
        this.childItemForm.template_text = '';
        this.optionList = [];
        this.templateTextEdited = false;
      }
      
      // 重新验证相关字段
      this.$nextTick(() => {
        if (this.$refs.childItemForm) {
          this.$refs.childItemForm.validateField('option_id');
          this.$refs.childItemForm.validateField('template_text');
        }
      });
    },
    
    // 填充默认选项
    fillDefaultOptions() {
      const inputType = Number(this.childItemForm.input_type);
      if (inputType === 1) {
        // 单选：通用的符合/不符合选项
        this.optionList = ['符合', '不符合', '不适用'];
      } else if (inputType === 3) {
        // 多选：设备检查选项
        this.optionList = ['设备完好', '清洁卫生', '记录完整', '操作规范'];
      }
      this.updateOptionId();
      this.$message.success('已填充示例选项');
    },
    
    // 选项管理方法
    addOption() {
      this.optionList.push('新选项');
      this.updateOptionId();
    },
    
    removeOption(index) {
      if (this.optionList.length > 1) {
        this.optionList.splice(index, 1);
        this.updateOptionId();
      }
    },
    
    updateOptionId() {
      // 将选项列表转换为逗号分隔的字符串
      this.childItemForm.option_id = this.optionList.filter(opt => opt.trim()).join(',');
    },
    
    // 初始化选项列表（从option_id反向生成）
    initOptionList() {
      if (this.childItemForm.option_id) {
        this.optionList = this.childItemForm.option_id.split(',').map(opt => opt.trim());
      } else {
        this.optionList = ['符合', '不符合'];
      }
    },
    
    // // 更新单个主项目的子项目统计
    // async updateChildItemCount(parentId) {
    //   try {
    //     const response = await listChildItems({ 
    //       parent_item_id: parentId,
    //       page: 1,
    //       page_size: 1
    //     });
    //     // 使用Vue.set确保响应式更新
    //     this.$set(this.childItemCounts, parentId, response?.count || 0);
    //   } catch (error) {
    //     console.error('更新子项目统计失败:', error);
    //   }
    // },
    
    // 生成建议的子项编号 - Linux内核式设计：智能建议，用户决定
    generateSuggestedChildItemNo() {
      if (!this.selectedMainItem || !this.selectedMainItem.item_no) {
        return '';
      }
      
      const mainItemNo = this.selectedMainItem.item_no;
      const existingChildNos = this.childItems
        .map(item => item.item_no)
        .filter(no => no && no.startsWith(mainItemNo + '.'))
        .map(no => {
          const suffix = no.substring(mainItemNo.length + 1);
          const num = parseInt(suffix, 10);
          return isNaN(num) ? 0 : num;
        })
        .sort((a, b) => b - a); // 降序排列
      
      // 找到最大编号，建议下一个
      const maxNo = existingChildNos.length > 0 ? existingChildNos[0] : 0;
      return `${mainItemNo}.${maxNo + 1}`;
    },
    
    // 获取下一个排序号
    getNextSortOrder() {
      if (this.childItems.length === 0) {
        return 10; // 起始值，便于后续插入
      }
      
      const maxSort = Math.max(...this.childItems.map(item => item.sort_order || 0));
      return maxSort + 10; // 每次递增10，便于后续调整顺序
    },
    
    // 获取智能模板文本建议
    getSmartTemplateText(inputType) {
      const suggestions = {
        2: '请输入检查结果', // 短文本：简短的数值、状态等
        4: '请详细描述检查情况和发现的问题' // 长文本：详细的描述、分析等
      };
      return suggestions[inputType] || '';
    },
    
    // 获取模板文本占位符
    getTemplateTextPlaceholder() {
      if (!this.templateTextEdited && this.childItemForm.template_text) {
        return '点击此处自定义模板内容...';
      }
      const inputType = Number(this.childItemForm.input_type);
      const placeholders = {
        2: '短文本模板，如：温度 {temp}°C，湿度 {humidity}%，状态正常',
        4: '长文本模板，如：检查 {设备名称} 运行状态：\n1. 外观检查：{外观状态}\n2. 运行参数：温度{temp}°C，压力{pressure}Pa\n3. 异常情况：{异常描述}'
      };
      return placeholders[inputType] || '请输入模板文本';
    },
    
    // 模板文本获得焦点时的处理
    handleTemplateTextFocus() {
      // 如果是智能建议的内容且用户未编辑过，清空内容让用户重新输入
      if (!this.templateTextEdited && this.childItemForm.template_text) {
        const smartText = this.getSmartTemplateText(Number(this.childItemForm.input_type));
        if (this.childItemForm.template_text === smartText) {
          this.childItemForm.template_text = '';
          this.templateTextEdited = true;
        }
      }
    },
    
    // 模板文本失去焦点时的处理
    handleTemplateTextBlur() {
      // 如果用户清空了内容，恢复智能建议
      if (!this.childItemForm.template_text.trim()) {
        this.templateTextEdited = false;
        const inputType = Number(this.childItemForm.input_type);
        this.childItemForm.template_text = this.getSmartTemplateText(inputType);
      }
    },
    
    // 模板文本输入时的处理
    handleTemplateTextInput() {
      // 用户开始输入，标记为已编辑
      if (!this.templateTextEdited) {
        this.templateTextEdited = true;
      }
    },
    
    // =============智能优化功能============= 
    
    // 获取删除确认文本 - 体现“好品味”：让用户明白将要发生什么
    getDeleteConfirmText(item) {
      const childCount = item.child_count || 0;
      if (childCount === 0) {
        return `确定删除主项目「${item.item_name}」？`;
      } else {
        return `确定删除主项目「${item.item_name}」及其${childCount}个子项目？\n\n注意：这将同时删除所有关联的子项目！`;
      }
    },
    
    // 智能批量删除 - 自动处理子项目
    async smartDeleteMainItem(item) {
      try {
        // 使用Vue.set设置loading状态
        this.$set(this.deletingItems, item.id, true);
        // 后端已经在数据库层面配置了CASCADE删除
        // 所以只需要删除主项目，子项目会自动删除
        const response = await deleteItem({ id: item.id });
        if (response.code === 200) {
          const childCount = item.child_count || 0;
          const message = childCount > 0 
            ? `已删除主项目「${item.item_name}」及其${childCount}个子项目`
            : `已删除主项目「${item.item_name}」`;
          this.$message.success(message);
          // 更新界面状态
          this.loadMainItems();
          if (this.selectedMainItem && this.selectedMainItem.id === item.id) {
            this.selectedMainItem = null;
            this.childItems = [];
          }
          // 清除模板缓存
          clearTemplateCache();
          // 通知父组件刷新数据
          this.$emit('refresh');
        } else {
          throw new Error(response.message || '删除失败');
        }
      } catch (error) {
        console.error('删除主项目失败:', error);
        this.$message.error('删除失败: ' + (error.message || '未知错误'));
      } finally {
        // 清除loading状态
        this.$delete(this.deletingItems, item.id);
      }
    },
    
    // 删除子项目
    async deleteChildItem(childId) {
      try {
        const response = await deleteChildItem({ id: childId });
        
        if (response && response.code === 200) {
          this.$message.success('删除成功');
          // 重新加载子项目列表
          this.loadChildItems(this.selectedMainItem.id);
          // 更新当前主项目的子项目数量
          await this.updateSingleItemChildCount(this.selectedMainItem.id);
          // 清除模板缓存
          clearTemplateCache();
          // 通知父组件刷新数据
          this.$emit('refresh');
        } else {
          this.$message.error(response?.message || '删除失败');
        }
      } catch (error) {
        console.error('删除子项目失败:', error);
        this.$message.error('删除失败: ' + (error.message || '未知错误'));
      }
    },
    
    // 更新单个主项目的子项目数量（用于增删改操作后的局部更新）
    async updateSingleItemChildCount(itemId) {
      try {
        // 优化：只获取第一页数据并使用 count 字段
        const response = await listChildItems({ 
          parent_item_id: itemId,
          page: 1,
          page_size: 1 // 只获取1条，主要是为了得到 count
        });
        
        if (response && response.code === 200) {
          // 优先使用 count 字段，如果没有则使用数组长度
          const count = response.data?.count ?? response.count ?? (response.data?.data || response.data || []).length;
          
          // 查找并更新对应的主项目
          const item = this.mainItems.find(i => i.id === itemId);
          if (item) {
            this.$set(item, 'child_count', count);
            // 如果是当前选中的主项目,也更新它
            if (this.selectedMainItem && this.selectedMainItem.id === itemId) {
              this.$set(this.selectedMainItem, 'child_count', count);
            }
          }
        }
      } catch (error) {
        console.error(`更新主项目 ${itemId} 的子项目数量失败:`, error);
      }
    },
    
    // =============模板关联管理============= 
    
    // 加载所有可用模板列表
    async loadTemplateList() {
      try {
        this.loadingTemplates = true;
        const response = await listTemplates({});
        
        if (response && response.code === 200) {
          const responseData = response.data;
          
          let templateData = [];
          if (responseData && responseData.data && Array.isArray(responseData.data)) {
            templateData = responseData.data;
          } else if (responseData && Array.isArray(responseData)) {
            templateData = responseData;
          } else {
            templateData = [];
          }
          
          this.$set(this, 'allTemplates', templateData);
          
          if (this.allTemplates.length === 0) {
            this.$message.warning('暂无可用模板，请先创建模板');
          }
        } else {
          this.$message.error('加载模板列表失败: ' + (response?.message || '未知错误'));
          this.allTemplates = [];
        }
      } catch (error) {
        this.$message.error('加载模板列表失败: ' + (error.message || '网络错误'));
        this.allTemplates = [];
      } finally {
        this.loadingTemplates = false;
      }
    },
    
    // 加载主项目的模板关联关系
    async loadItemTemplateRelations(itemId) {
      try {
        const response = await getItemTemplateRelations({ 
          id: itemId 
        });
        
        if (response && response.code === 200) {
          const itemData = response.data;
          this.selectedTemplates = itemData.related_templates 
            ? itemData.related_templates.map(template => template.id)
            : [];
        } else {
          this.selectedTemplates = [];
        }
      } catch (error) {
        this.selectedTemplates = [];
      }
    },
    
    // 模板选项过滤
    filterTemplateOption(input, option) {
      if (!input) return true;
      
      const template = this.allTemplates.find(t => t.id == option.value);
      if (!template) return false;
      
      const searchText = input.toLowerCase();
      const templateName = (template.template_name || template.name || template.title || '').toLowerCase();
      const description = (template.description || '').toLowerCase();
      
      return templateName.includes(searchText) || description.includes(searchText);
    },
    

  }
};
</script>

<style scoped>
.manager-container {
  display: flex;
  height: 100%;
  gap: 16px;
}

.left-panel, .right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.left-panel {
  max-width: 350px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}

.panel-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.item-list, .child-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.item-card {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.item-card:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.item-card.active {
  border-color: #1890ff;
  background: #e6f7ff;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.item-tags {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 模板关联信息样式 */
.template-relation-info {
  margin-top: 4px;
  padding: 4px 8px;
  background: #f0f8ff;
  border-radius: 4px;
  border-left: 3px solid #1890ff;
}

.item-no {
  font-weight: 500;
  color: #1890ff;
}

.item-name {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-actions {
  margin-bottom: 8px;
}

.child-count {
  font-size: 12px;
  color: #666;
}

.child-item {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;
  background: #fafafa;
}

.child-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.child-main {
  flex: 1 1 auto;
  min-width: 0;
}

.child-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.child-no {
  font-weight: 500;
  color: #1890ff;
}

.child-name {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 固定宽度样式：当标题过长时固定显示宽度，超出用省略号，hover 用 tooltip 显示完整 */
.child-name.fixed-width {
  width: 520px; /* 写死宽度，按需调整 */
  display: inline-block;
}

.child-actions {
  text-align: right;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

/* 选项编辑器样式 */
.option-editor {
  .option-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
}

.option-preview {
  margin-top: 8px;
  padding: 4px 8px;
  background: #f5f5f5;
  border-radius: 4px;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 6px 6px;
}

/* 表单样式优化 */
.ant-form-model-item {
  margin-bottom: 16px;
}

.ant-form-model-item-label {
  font-weight: 500;
}

/* 选择框样式 */
.ant-select {
  width: 100%;
}

/* 输入框提示文字样式 */
.input-hint {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  line-height: 1.4;
}

/* 加载状态样式 */
.item-list {
  position: relative;
  min-height: 200px;
}

/* 抽屉内容区域 */
.ant-drawer-body {
  padding-bottom: 60px; /* 为底部按钮留出空间 */
}

/* 智能建议模板文本样式 */
.template-suggested {
  background: linear-gradient(45deg, #f6ffed 25%, transparent 25%), 
              linear-gradient(-45deg, #f6ffed 25%, transparent 25%), 
              linear-gradient(45deg, transparent 75%, #f6ffed 75%), 
              linear-gradient(-45deg, transparent 75%, #f6ffed 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  border-color: #b7eb8f !important;
  color: #389e0d !important;
  font-style: italic;
  transition: all 0.3s ease;
}

.template-suggested:hover {
  background: #f6ffed;
  border-color: #52c41a !important;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.2);
}

.template-suggested:focus {
  background: #fff !important;
  border-color: #40a9ff !important;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  font-style: normal;
}
</style>